import { render, staticRenderFns } from "./BackendMission.vue?vue&type=template&id=6c179c28&"
import script from "./BackendMission.vue?vue&type=script&lang=js&"
export * from "./BackendMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports